
import { defineComponent, nextTick, onBeforeMount, onMounted, ref, watch } from 'vue'
import KTHeader from '@/components/layout/header/Header.vue'
import KTContent from '@/components/layout/Content.vue'
import LayoutService from '@/services/LayoutService'
import { reinitializeComponents } from '@/assets/metronik/ts/keenthemes'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'MainLayout',
  components: {
    KTHeader,
    KTContent
  },
  setup () {
    const route = useRoute()
    const withHeader = ref(true)

    onBeforeMount(() => {
      LayoutService.init()
    })

    onMounted(() => {
      const queryParams = new URLSearchParams(window.location.search)
      const withHeaderParam = queryParams.get('withHeader')
      withHeader.value = withHeaderParam !== 'false'
      nextTick(() => {
        reinitializeComponents()
      })
    })

    watch(() => route.path, () => { nextTick(() => { reinitializeComponents() }) })

    return {
      withHeader
    }
  }
})
